enum HttpFetchStatus {
    Idle,
    Loading,
    Failed,
    Success,
}

export default HttpFetchStatus;